// extracted by mini-css-extract-plugin
export default {"root":"styles_root__nl6VP","label":"styles_label__MX3Sv","selected":"styles_selected__REMOw"};